
import Vue from 'vue'

export type CommunitySubMenu = {
  icon: string
  title: string
  key: string
}

export default Vue.extend({
  name: 'CommunitySubMenu',
  data() {
    return {
      menuItems: [
        {
          icon: '$commDiscordIcon',
          title: 'Discord',
          tooltip: 'Discord',
          key: '__discord',
        },
        {
          icon: '$redditSocialIcon',
          title: 'Reddit',
          tooltip: 'Reddit',
          key: '__reddit',
        },
        {
          icon: '$twitterSocialIcon',
          title: 'Twitter',
          tooltip: 'X',
          key: '__twitter',
        },
        {
          icon: '$commUdemyIcon',
          title: 'Udemy',
          tooltip: 'Udemy Courses',
          key: '__udemy',
        },
        {
          icon: '$commYoutubeIcon',
          title: 'Youtube',
          tooltip: 'Youtube',
          key: '__youtube',
        },
      ],
    }
  },
  methods: {
    communityItemPressed(page: string) {
      this.$router.push(`/community/${page}`)
    },
    menuItemLink(menuItem: CommunitySubMenu) {
      if (process.browser)
        switch (menuItem.title) {
          case 'Youtube':
            return 'https://www.youtube.com/channel/UCnui50w5BC_P7pfrF0XwoKg'
          case 'Twitter':
            return 'https://www.x.com/machinationsio'
          case 'Reddit':
            return 'https://www.reddit.com/r/Machinations/'
          case 'Udemy':
            return 'https://www.udemy.com/course/machinations-essentials/'
          default:
            return 'https://discord.gg/EqKqWAJ'
        }
    },
    isActiveRoute(type: string) {
      if (type === 'explore') {
        return this.$route.path.endsWith('/community/explore')
      }
      return this.$route.query.filter === type
    },
  },
})
